import { z } from 'zod/v4';

export const columns = {
  active_flag: z.string().nullable(),
  addr_1: z.string().nullable(),
  addr_2: z.string().nullable(),
  addr_3: z.string().nullable(),
  arrival_code: z.string().nullable(),
  buyer: z.string().nullable(),
  city: z.string().nullable(),
  contact_email: z.string().nullable(),
  contact_fax: z.string().nullable(),
  contact_first_name: z.string().nullable(),
  contact_honorific: z.string().nullable(),
  contact_initial: z.string().nullable(),
  contact_last_name: z.string().nullable(),
  contact_mobile: z.string().nullable(),
  contact_phone: z.string().nullable(),
  contact_phone_ext: z.string().nullable(),
  contact_position: z.string().nullable(),
  contact_salutation: z.string().nullable(),
  country: z.string().nullable(),
  country_id: z.string().nullable(),
  currency_id: z.string(),
  date_of_birth: z.date().nullable(),
  def_carrier_id: z.string().nullable(),
  def_exp_acct_id: z.string().nullable(),
  def_exp_gl_acct_id: z.string().nullable(),
  def_lbl_format_id: z.string().nullable(),
  def_payb_acct_id: z.string().nullable(),
  def_sls_tax_grp_id: z.string().nullable(),
  def_terms_id: z.string().nullable(),
  def_trans_currency: z.string().nullable(),
  disp_pallet_req: z.string().nullable(),
  dispatch_addr_id: z.string().nullable(),
  email_empl_on_chg_order: z.string(),
  email_empl_on_inv_paid: z.string(),
  email_empl_on_new_order: z.string(),
  email_empl_on_po_receipt: z.string(),
  email_vend_on_chg_order: z.string(),
  email_vend_on_new_order: z.string(),
  email_vend_on_po_receipt: z.string(),
  free_on_board: z.string().nullable(),
  id: z.string(),
  internal_vendor: z.string().nullable(),
  last_order_date: z.date().nullable(),
  match_high_pct: z.number().nullable(),
  match_low_pct: z.number().nullable(),
  match_type: z.string(),
  mode_of_transport: z.number().nullable(),
  modify_date: z.date().nullable(),
  name: z.string().nullable(),
  nature_of_trans: z.number().nullable(),
  open_date: z.date().nullable(),
  payee_ref_code: z.string().nullable(),
  payment_method: z.string(),
  place_of_birth: z.string().nullable(),
  pref_order_medium: z.string().nullable(),
  prevent_edit_po_receipt: z.string().nullable(),
  priority: z.number().nullable(),
  qa_percentage: z.number().nullable(),
  remit_to_addr_1: z.string().nullable(),
  remit_to_addr_2: z.string().nullable(),
  remit_to_addr_3: z.string().nullable(),
  remit_to_city: z.string().nullable(),
  remit_to_country: z.string().nullable(),
  remit_to_country_id: z.string().nullable(),
  remit_to_name: z.string().nullable(),
  remit_to_state: z.string().nullable(),
  remit_to_zipcode: z.string().nullable(),
  report_1099_misc: z.string(),
  return_trans: z.number().nullable(),
  rowid: z.number(),
  sex: z.string().nullable(),
  ship_via: z.string().nullable(),
  shipto_id: z.string().nullable(),
  siret_number: z.number().nullable(),
  site_id: z.string().nullable(),
  social_security_no: z.string().nullable(),
  state: z.string().nullable(),
  state_of_birth: z.string().nullable(),
  status_eff_date: z.date(),
  tax_id_number: z.string().nullable(),
  terms_description: z.string().nullable(),
  terms_disc_date: z.date().nullable(),
  terms_disc_days: z.number().nullable(),
  terms_disc_percent: z.number().nullable(),
  terms_disc_type: z.string(),
  terms_net_date: z.date().nullable(),
  terms_net_days: z.number().nullable(),
  terms_net_type: z.string(),
  trans_code: z.string().nullable(),
  type: z.string().nullable(),
  udf_layout_id: z.string().nullable(),
  user_1: z.string().nullable(),
  user_10: z.string().nullable(),
  user_2: z.string().nullable(),
  user_3: z.string().nullable(),
  user_4: z.string().nullable(),
  user_5: z.string().nullable(),
  user_6: z.string().nullable(),
  user_7: z.string().nullable(),
  user_8: z.string().nullable(),
  user_9: z.string().nullable(),
  vat_always_disc: z.string(),
  vat_book_code_i: z.string().nullable(),
  vat_book_code_m: z.string().nullable(),
  vat_code: z.string().nullable(),
  vat_discounted: z.string(),
  vat_exempt: z.string().nullable(),
  vat_override_seq: z.string(),
  vat_registration: z.string().nullable(),
  vend_bank_acct_id: z.string().nullable(),
  vendor_country_id: z.string().nullable(),
  vendor_group_id: z.string().nullable(),
  web_url: z.string().nullable(),
  withholding_code: z.string().nullable(),
  zipcode: z.string().nullable(),
};
